import React from 'react'
import { propTypes } from '../../helpers'
import { TenantCard } from '../../components'
import { useAsset } from '../../hooks'

const TenantDetails = ({ tenant }) => {
  const { asset } = useAsset(tenant.loginImageId)
  const imgSrc = asset
    ? `data:${asset.contentType};base64,${asset.content}`
    : '/login.png'
  const imgAlt = asset
    ? asset.altText
    : 'Background image featuring the Ohio State seal, representing the university’s central campus'

  return <TenantCard tenant={tenant} imgSrc={imgSrc} imgAlt={imgAlt} />
}

TenantDetails.propTypes = {
  tenant: propTypes.tenantPropType
}

export { TenantDetails }
